import { InputAdornment, TextFieldProps } from "@mui/material";
import TextField from "@mui/material/TextField";
import { get } from "radash";
import { Controller, UseControllerProps } from "react-hook-form";

import {
  InputRegexFormatterTypes,
  useInputRegexFormatter,
} from "@hooks/useInputRegexFormatter";

export type InputProps = TextFieldProps &
  UseControllerProps<any> & {
    formatterRules?: InputRegexFormatterTypes;
    formatOnChange?: (value: string) => string;
    icon?: React.ReactNode;
  };

const Input = (props: InputProps) => {
  const {
    control,
    name,
    formatterRules = [],
    formatOnChange,
    icon,
    ...rest
  } = props;

  const inputFormatter = useInputRegexFormatter(formatterRules);

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { ref, onChange, ...restField },
        formState: state,
      }) => (
        <TextField
          {...restField}
          InputProps={
            icon
              ? {
                  startAdornment: (
                    <InputAdornment position="start">{icon}</InputAdornment>
                  ),
                }
              : undefined
          }
          fullWidth
          error={!!get(state.errors, name)}
          placeholder={rest.placeholder || (rest.label as string)}
          title={rest.label as string}
          onChange={(e) => {
            let value = e.target.value || "";
            value = inputFormatter(value);
            if (formatOnChange) {
              onChange(formatOnChange(value));
              return;
            }

            onChange(value);
          }}
          {...rest}
        />
      )}
    />
  );
};

export default Input;
